<template>
  <div>
    <UserPlaylists ref="userPlaylistRef" />
    <Footer />
  </div>
</template>

<script>
import UserPlaylists from "@/components/userplaylists/UserPlaylists.vue";
import Footer from "@/components/navigation/Footer.vue";

export default {
  name: "ListsPage",
  components: { Footer, UserPlaylists },
  metaInfo: {
    title: "My Playlists",
  },
  mounted() {
    this.checkRoute();
  },
  methods: {
    checkRoute() {
      if (this.$route.query.l) {
        this.$refs.userPlaylistRef.showPlaylist(this.$route.query.l);
        this.$router.replace({
          name: this.$route.name,
        });
      }
    },
  },
  watch: {
    $route() {
      this.checkRoute();
    },
  },
};
</script>

<style scoped lang="scss"></style>
